import { DEFAULT_FEATURE_KEY } from '../constants';
import { getCookieFeatureNames, getBrowserFeatureQueryKeys } from '../selectors';
import { getCookieValue, hex2string, stripLeadingText } from '../utils';
import browser from './browser';

var _browser = browser({
    DEFAULT_FEATURE_KEY: DEFAULT_FEATURE_KEY,
    getCookieFeatureNames: getCookieFeatureNames,
    getBrowserFeatureQueryKeys: getBrowserFeatureQueryKeys,
    getCookieValue: getCookieValue,
    hex2string: hex2string,
    stripLeadingText: stripLeadingText
});

var isClientFeatureEnabled = _browser.isClientFeatureEnabled,
    getFeatureParamsFromCookie = _browser.getFeatureParamsFromCookie;
export { isClientFeatureEnabled, getFeatureParamsFromCookie };